import React from "react";

export const FilterText = (props) => {
    
    const { id, labelValue, filters, setFilters } = props

    function handleInputChange(event) {
        const { name, value } = event.target;
        setFilters({
            ...filters,
            [name]: props.formatter?props.formatter(value):value
        });
    }

    return (
        <div className="filter normalText normalSmallSize">
            <div className="filterLabelContainer">
                {props.icon}
                <label htmlFor={id}>{labelValue}:</label>
            </div>
            <input
                type="text"
                name={id}
                placeholder={props.placeholder?props.placeholder:null}
                value={props.formatter?props.formatter(filters[id]):filters[id]}
                onChange={handleInputChange}
            />
        </div>
    );
}

export default FilterText;